import moment from 'moment';

export const defaultDateFormat = 'dddd Do MMMM YYYY';

export const formatDateToStr = (date: Date, format: string): string => moment(date).format(format);

export const formatStrToDate = (date: string, format: string): Date =>
    moment(date, format).toDate();
